import productCardClickService from "../services/ProductCardClickService";
import elementService from "@/common/ElementService";

export default class PackageBlockbusterPageService {
    private static readonly Second = 1000;

    public init(): void {
        productCardClickService.initForContainer(elementService.querySelector<HTMLDivElement>("#content"));
        this.initCountdowns();
    }

    private initCountdowns(): void {
        setInterval(() => this.runEndCountDown(), PackageBlockbusterPageService.Second);
    }

    private runEndCountDown(): void {
        const date = new Date();
        const hours = 24 - date.getHours() - 1;
        const minutes = 60 - date.getMinutes();
        const seconds = 60 - date.getSeconds();
        const countdown = `${hours}:${minutes.toString().padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;

        for (const countdownSpan of document.querySelectorAll<HTMLSpanElement>(".js-kt-countdown")) {
            countdownSpan.innerHTML = countdown;
        }
    }
}
